module.exports = __webpack_public_path__ + "static/t_321_718-6700e3b9046e853c07114cfe221ece6f.png";